module.exports = __webpack_public_path__ + "static/img/theme_2.234b1a70.png";